/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RightInputs */

const en_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right`)
};

const es_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecha`)
};

const fr_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droite`)
};

const de_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechts`)
};

const ja_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右`)
};

const zh_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右`)
};

const ar_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمين`)
};

const id_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanan`)
};

const it_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destra`)
};

const ru_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Право`)
};

const pt_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direita`)
};

const ko_right = /** @type {(inputs: RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오른쪽`)
};

/**
* | output |
* | --- |
* | "Right" |
*
* @param {RightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const right = /** @type {((inputs?: RightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_right(inputs)
	if (locale === "es") return es_right(inputs)
	if (locale === "fr") return fr_right(inputs)
	if (locale === "de") return de_right(inputs)
	if (locale === "ja") return ja_right(inputs)
	if (locale === "zh") return zh_right(inputs)
	if (locale === "ar") return ar_right(inputs)
	if (locale === "id") return id_right(inputs)
	if (locale === "it") return it_right(inputs)
	if (locale === "ru") return ru_right(inputs)
	if (locale === "pt") return pt_right(inputs)
	return ko_right(inputs)
});